import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { PageDataPanelComponent } from '../../shared/page-layout/page-data-panel.component';
import { PageHeroComponent } from '../../shared/page-layout/page-hero.component';
import { PageShellComponent } from '../../shared/page-layout/page-shell.component';
import { SessionStorageService } from '../../services/session-storage.service';
import { ContractsService } from '../contracts.service';
import { ContractTemplate } from '../models/contract-drafting.model';

@Component({
  selector: 'app-contract-template-list',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule, TableModule, TagModule, PageShellComponent, PageHeroComponent, PageDataPanelComponent],
  templateUrl: './contract-template-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContractTemplateListComponent implements OnInit {
  templates = signal<ContractTemplate[]>([]);
  companyId?: number;

  constructor(private contractsService: ContractsService, private sessionStorageService: SessionStorageService) {}

  ngOnInit() {
    this.companyId = this.sessionStorageService.getCompany()?.id;
    this.contractsService.getContractTemplates(this.companyId).subscribe(templates => this.templates.set(templates || []));
  }
}
